import { apiFetch } from './api';
import type { Cell, Difficulty, Tile } from '../types';

// Server-stored puzzle progress so a player can start on the website
// and finish on the iOS app (or vice versa) without losing placements.
// One row per (user, puzzle-date, difficulty); the server upserts on
// every PUT and lets the row stick around past solve so the home/preview
// view can render the completed board on later visits.

export interface PuzzleProgress {
  puzzleDate: string;
  difficulty: Difficulty;
  cells: Cell[];
  bag: Tile[];
  solved: boolean;
  solvedAt: string | null;
  elapsedMs: number | null;
  updatedAt: string;
}

interface SaveBody {
  cells: Cell[];
  bag: Tile[];
  solved?: boolean;
  elapsedMs?: number;
}

export async function loadProgress(
  puzzleDate: string,
  difficulty: Difficulty,
): Promise<PuzzleProgress | null> {
  const res = await apiFetch(`/progress/${puzzleDate}/${encodeURIComponent(difficulty)}`);
  if (!res.ok) return null;
  const data = await res.json();
  return (data?.progress as PuzzleProgress) ?? null;
}

export async function saveProgress(
  puzzleDate: string,
  difficulty: Difficulty,
  body: SaveBody,
): Promise<boolean> {
  const res = await apiFetch(`/progress/${puzzleDate}/${encodeURIComponent(difficulty)}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
  return res.ok;
}

export async function clearProgress(
  puzzleDate: string,
  difficulty: Difficulty,
): Promise<boolean> {
  const res = await apiFetch(`/progress/${puzzleDate}/${encodeURIComponent(difficulty)}`, {
    method: 'DELETE',
  });
  return res.ok;
}
